import { styled } from '@linaria/react';

export const Wrapper = styled.div``;

export const Label = styled.label`
	display: block;
	margin-bottom: 8px;
	color: var(--color-white-05);
	font-size: 16px;
	line-height: 20px;
`;

export const Description = styled.div`
	margin-top: 4px;
`;

export const Error = styled.div`
	margin-top: 4px;
`;
